import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallInfo({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#0C8BE6" cx={8} cy={8} r={8} />
        <path
          d="M8.5 7.25c.28 0 .5.22.5.5v3.75a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7.75c0-.28.22-.5.5-.5h1zM8 4a1.13 1.13 0 110 2.25A1.13 1.13 0 018 4z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

SvgTickSmallInfo.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallInfo.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickSmallInfo svgRef={ref} {...props} />);
export default ForwardRef;
